/**
 * 統一的日誌記錄服務
 * 根據環境(開發/生產)控制日誌輸出
 * 支援多種日誌級別
 */
import { deviceService } from './deviceService'

// 定義日誌參數類型
type LogArgs = (string | number | boolean | object | null | undefined)[]
type ApiCallParams = Record<string, unknown> | null | undefined
type ApiCallResponse = Record<string, unknown> | null | undefined
type UserActionDetails = Record<string, unknown> | null | undefined

export class LogService {
  private static readonly isProduction = process.env.NODE_ENV === 'production'

  /**
   * 信息日誌
   */
  public static info(message: string, ...args: LogArgs): void {
    if (!this.isProduction) {
      // 開發環境：輸出到控制台
      console.info(`[INFO] ${message}`, ...args)
    }
    // TODO: 在此處添加生產環境的日誌收集邏輯，例如發送到遠程日誌服務
  }

  /**
   * 警告日誌
   */
  public static warn(message: string, ...args: LogArgs): void {
    if (!this.isProduction) {
      // 開發環境：輸出到控制台
      console.warn(`[WARN] ${message}`, ...args)
    }
    // TODO: 在此處添加生產環境的警告日誌收集邏輯
  }

  /**
   * 錯誤日誌
   */
  public static error(message: string, error?: unknown, ...args: LogArgs): void {
    // 在開發環境中輸出到控制台，生產環境中發送到日誌服務
    if (!this.isProduction) {
      // 開發環境：輸出到控制台
      console.error(`[ERROR] ${message}`, error, ...args)
    }
    // TODO: 任何環境下都必須記錄錯誤日誌，並可選地發送到遠程服務
  }

  /**
   * 調試日誌
   */
  public static debug(message: string, ...args: LogArgs): void {
    if (!this.isProduction) {
      // 開發環境：輸出到控制台
      console.debug(`[DEBUG] ${message}`, ...args)
    }
  }

  /**
   * 追蹤日誌
   */
  public static trace(message: string, ...args: LogArgs): void {
    if (!this.isProduction) {
      // 開發環境：輸出到控制台
      console.trace(`[TRACE] ${message}`, ...args)
    }
  }

  /**
   * 記錄 API 調用日誌
   */
  public static logApiCall(endpoint: string, method: string, params?: ApiCallParams, response?: ApiCallResponse): void {
    this.info('API call', { endpoint, method, params, response })
  }

  /**
   * 記錄用戶操作日誌
   */
  public static logUserAction(action: string, details?: UserActionDetails): void {
    this.info('User action', { action, details, timestamp: new Date().toISOString() })
  }

  /**
   * 記錄錯誤並顯示用戶友好的錯誤訊息
   */
  public static logAndShowError(message: string, error?: unknown, userMessage?: string): void {
    this.error(message, error)
    
    // 在原生環境中可以使用 Toast 或其他通知方式
    if (deviceService.isNative()) {
      // TODO: 使用原生通知組件
      // 移除 console.log，使用適當的日誌記錄
    } else {
      // Web 環境可以使用瀏覽器的 alert 或其他方式
      if (userMessage) {
        alert(userMessage)
      }
    }
  }
}
